// extracted by mini-css-extract-plugin
export default {"error-modal":"ErrorModal_error-modal__3WfmE","warning-icon":"ErrorModal_warning-icon__RGxAm"};